import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  ScrollRestoration,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// import PrivacyPolicy from "./PrivacyPolicy";
import AccoutDelete from "./components/AccoutDelete";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import TermsOfService from "./screens/TermsOfService";
import AboutUs from "./screens/AboutUs";
import Homeowner from "./screens/Homeowner";
import Rental from "./screens/Rental";
import ApplicationForm from "./screens/ApplicationForm";
import ContactUsPage from "./screens/ContactUs";
import VerifyEmail from "./screens/VerifyEmail";
import DocumentVerification from "./screens/DocumentVerification";
import DocumentVerificationPast from "./screens/DocumentVerificationPast";
import DocumentVerificationLogin from "./screens/DocumentVerificationLogin";
import RequireDocVerificationAuth from "./components/DocumentVerification/RequireDocVerificationAuth";
import AdminLogin from "./admin/AdminLogin";
import UserManagement from "./admin/UserManagement";
import DocumentVerificationKashyap from "./screens/DocumentVerificationKashyap";
import FeatureFlags from "./admin/FeatureFlags";

const RootLayout = () => {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "",
        element: <Rental />,
      },
      {
        path: "homeowner",
        element: <Homeowner />,
      },
      {
        path: "about",
        element: <AboutUs />,
      },
      {
        path: "policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "terms",
        element: <TermsOfService />,
      },
      {
        path: "accountDelete",
        element: <AccoutDelete />,
      },
      {
        path: "contact-us",
        element: <ContactUsPage />,
      },
      {
        path: "application/:id",
        element: <ApplicationForm />,
      },
      {
        path: "verify-email",
        element: <VerifyEmail />,
      },
      {
        path: "document-verification",
        element: (
          <RequireDocVerificationAuth>
            <DocumentVerification />
          </RequireDocVerificationAuth>
        ),
      },
      {
        path: "document-verification/past",
        element: (
          <RequireDocVerificationAuth>
            <DocumentVerificationPast />
          </RequireDocVerificationAuth>
        ),
      },
      {
        path: "document-verification/login",
        element: <DocumentVerificationLogin />,
      },
      {
        path: "admin/login",
        element: <AdminLogin />,
      },
      {
        path: "admin/user-management",
        element: <UserManagement />,
      },
      {
        path: "user/document-verification",
        element: <DocumentVerificationKashyap />,
      },
      {
        path: "admin/feature-flags",
        element: <FeatureFlags />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <ToastContainer />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
